// App.js
import React, { useEffect } from 'react';
import { BrowserRouter as Router } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { NotificationProvider } from './contexts/NotificationContext';
import { ThemeProvider } from './contexts/ThemeContext';
import { CartProvider } from './contexts/CartContext'; // ADD THIS IMPORT
import AppRoutes from './routes/AppRoutes';
import ErrorBoundary from './components/ErrorBoundary';
import { initializeFirestoreCollections } from './scripts/initializeFirestore';
import { Toaster } from 'react-hot-toast'; // ADD THIS IMPORT if you want toast notifications

function App() {
  useEffect(() => {
    // Initialize collections on app start (optional)
    initializeFirestoreCollections().catch(console.error);
  }, []);
  
  return (
    <ErrorBoundary>
      <Router>
        <AuthProvider>
          <NotificationProvider>
            <ThemeProvider>
              <CartProvider> {/* ADD THIS - CartProvider wrapped around AppRoutes */}
                <AppRoutes />
                <Toaster position="top-right" /> {/* ADD THIS for toast notifications */}
              </CartProvider> {/* ADD THIS */}
            </ThemeProvider>
          </NotificationProvider>
        </AuthProvider>
      </Router>
    </ErrorBoundary>
  );
}

export default App;